<template>
  <div class="admin-page admin-inquiry">
    <h1>문의 관리</h1>

    <!-- 문의 수신 이메일 설정 (여러 개) -->
    <div class="mail-setting">
      <p class="ms-title">문의 수신 이메일</p>
      <p class="ms-desc">
        문의하기 폼으로 접수된 메일이 아래 <strong>모든 주소</strong>로 발송됩니다.
        (비워 두면 기본값 sales@vazilcompany.com 사용)
      </p>

      <div v-if="emails.length" class="ms-chips">
        <span v-for="(em, i) in emails" :key="em" class="ms-chip">
          {{ em }}
          <button type="button" class="ms-chip-x" @click="removeEmail(i)">×</button>
        </span>
      </div>

      <div class="ms-input-row">
        <input
          v-model="newEmail"
          type="email"
          class="ms-input"
          placeholder="이메일 입력 후 Enter 또는 추가"
          @keydown.enter.prevent="addEmail"
        />
        <button type="button" class="ms-btn ms-btn-add" @click="addEmail">추가</button>
        <button
          type="button"
          class="ms-btn ms-btn-save"
          :disabled="savingEmail"
          @click="saveMailSetting"
        >
          {{ savingEmail ? '저장 중…' : '저장' }}
        </button>
      </div>
    </div>

    <vhp-table
      :headers="headers"
      :items="InsquiryList"
    >
      <!-- 상세보기 아이콘 -->
      <template #item-edit="{ item }">
        <img
          @click="openDetail(item)"
          src="@/assets/image/edit.svg"
          height="15"
          class="pointer"
        />
      </template>

      <!-- 첨부파일 다운로드 -->
      <template #item-attachment="{ item }">
        <div v-if="item.attachment?.url">
          <a
            target="_blank"
            :href="item.attachment.url"
            :download="item.attachment.filename"
          >
            다운로드
            <img src="@/assets/image/download.svg" height="18" />
          </a>
        </div>
        <div v-else>-</div>
      </template>
    </vhp-table>

    <!-- 상세 보기 Dialog -->
    <vhp-dialog
      title="문의 내용"
      id="inquiry-detail"
      ref="detail"
      width="370"
      height="400"
    >
      <template #content>
        <div class="inquiry-detail">
          <p class="label">연락처</p>
          <p class="value">{{ detailItem.phoneNumber }}</p>

          <p class="label">이메일</p>
          <p class="value">{{ detailItem.email }}</p>

          <div class="divider"></div>

          <p class="content">{{ detailItem.content }}</p>

          <div v-if="detailItem.attachmentName" class="attachment-area">
            <div class="divider"></div>
            <p class="label">첨부파일</p>
            <a
              :href="detailItem.attachmentName"
              target="_blank"
              class="download-link"
            >
              다운로드하기
              <img src="@/assets/image/download.svg" height="18" />
            </a>
          </div>
        </div>
      </template>
    </vhp-dialog>


  </div>
</template>

<script>
export default {
  name: 'InquiryLog',
  data() {
    return {
      // 테이블 헤더
      headers: [
        { text: '회사명', value: 'companyName' },
        { text: '이름', value: 'name' },
        { text: '문의유형', value: 'contactType' },
        { text: '날짜', value: 'createdDate' },
        { text: '상세보기', value: 'edit', sortable: false },
      ],
      // 데이터
      InsquiryList: [],
      detailItem: {},
      // 문의 수신 이메일 설정 (여러 개)
      emails: [],
      newEmail: '',
      savingEmail: false,
    };
  },

  created() {
    this.getInquiryList();   // 화면 로드시 자동 호출
    this.loadMailSetting();  // 수신 이메일 설정 불러오기
  },

  methods: {
    // ✅ DB에서 목록 받아오기
    async getInquiryList() {
      try {
        const res = await this.$axios.get("/inquiry"); //console.log(res.data);
        this.InsquiryList = res.data;   // ✅ 테이블에 바로 넣기

      } catch (err) {
        console.error(err);
      }
    },

    // 수신 이메일 설정 불러오기
    async loadMailSetting() {
      try {
        const res = await this.$axios.get("/mail-setting");
        this.emails = Array.isArray(res.data?.inquiryEmails)
          ? [...res.data.inquiryEmails]
          : [];
      } catch (err) {
        console.error(err);
      }
    },

    // 입력한 이메일을 목록에 추가
    addEmail() {
      const v = this.newEmail.trim().replace(/,+$/, '').trim();
      if (!v) return;
      const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!EMAIL_RE.test(v)) {
        window.alert('올바른 이메일 형식을 입력하세요.');
        return;
      }
      if (!this.emails.includes(v)) this.emails.push(v);
      this.newEmail = '';
    },

    // 목록에서 이메일 제거
    removeEmail(i) {
      this.emails.splice(i, 1);
    },

    // 수신 이메일 설정 저장
    async saveMailSetting() {
      if (this.newEmail.trim()) this.addEmail();
      if (
        this.emails.length === 0 &&
        !window.confirm('등록된 수신 이메일이 없습니다. 기본값(sales@vazilcompany.com)으로 발송됩니다. 저장할까요?')
      ) {
        return;
      }
      this.savingEmail = true;
      try {
        await this.$axios.put("/mail-setting", { inquiryEmails: this.emails });
        window.alert('저장되었습니다.');
      } catch (err) {
        console.error(err);
        window.alert('저장에 실패했습니다.');
      } finally {
        this.savingEmail = false;
      }
    },

    // ✅ 상세보기 열기
    openDetail(item) {
    this.detailItem = item;   // ✅ 클릭한 항목의 전체 데이터 저장
    this.$refs.detail.load(); // Dialog 열기
  },
  },
};
</script>

<style lang="scss" src="./inquiry.scss"></style>
